import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaTasks, FaCubes, FaFoursquare } from "react-icons/fa";
import { IoIosArrowDown, IoMdSettings } from "react-icons/io";
import { GoDash } from "react-icons/go";
import { IoColorFilterOutline } from "react-icons/io5";
import { BsFiletypeRaw } from "react-icons/bs";
import { SiCloudfoundry } from "react-icons/si";
import Logo from "../../images/logo/logo.png";
import Logo1 from "../../images/logo/logo1.png";
import { AiFillQqCircle } from "react-icons/ai";
import { LiaGitlab } from "react-icons/lia";
import { TbBrandProducthunt } from "react-icons/tb";
import { PiCompassToolFill } from "react-icons/pi";

const Sidebar = ({ sidebarOpen, setSidebarOpen, sidebarCollapsed }) => {
  const location = useLocation();
  const { pathname } = location;
  const sidebar = useRef(null);
  const [hoveredGroup, setHoveredGroup] = useState(null);
  const [openGroups, setOpenGroups] = useState({});

  const toggleGroup = (key) => {
    setOpenGroups((prev) => {
      const newState = {};
      Object.keys(prev).forEach((k) => {
        newState[k] = false;
      });
      newState[key] = !prev[key];
      return newState;
    });
  };

  useEffect(() => {
    setOpenGroups({});
  }, [pathname]);

  useEffect(() => {
    const defaultOpen = {};
    menuGroups.forEach((group) => {
      if (group.children.some((item) => pathname.startsWith(item.path))) {
        defaultOpen[group.key] = true;
      }
    });
    setOpenGroups(defaultOpen);
  }, [pathname]);

  const menuGroups = [
    {
      key: "die-management",
      label: "Die Management",
      icon: <FaTasks />,
      children: [
        { label: "Die Status", path: "/die-management/die-status" },
        { label: "Die Supplier", path: "/die-management/supplier-die" },
        { label: "Location", path: "/die-management/location" },
        { label: "Tooling Size", path: "/die-management/toolingSize" },
        { label: "Die Type", path: "/die-management/dieType" },
        { label: "Die Master", path: "/die-management/die-master" },
      ],
    },
    {
      key: "tooling-Entry",
      label: "Tooling-Entry",
      icon: <PiCompassToolFill />,
      children: [
        { label: "Tooling-Entry", path: "/tooling-Entry" },
        { label: "Tooling-Type", path: "/tooling-type" },
      ],
    },
    {
      key: "sales-order",
      label: "Sales Order",
      icon: <FaCubes />,
      children: [
        { label: "Customer", path: "/sales-orders/sales-customer" },
        { label: "Alloy", path: "/sales-orders/alloy" },
        { label: "Order Status", path: "/sales-orders/order-status" },
        { label: "Unit Conversion", path: "/sales-orders/unit-conversion" },
        { label: "Orders", path: "/sales-orders/order-master" },
      ],
    },
    {
      key: "order-plan",
      label: "Order Plan",
      icon: <IoColorFilterOutline />,
      children: [{ label: "Order Plan View", path: "/order-plan-view" }],
    },
    {
      key: "raw-material",
      label: "Raw Material",
      icon: <BsFiletypeRaw />,
      children: [
        { label: "Material Master", path: "/raw-material" },
        { label: "Material Inward", path: "/material-inward" },
        { label: "All Stocks", path: "/all-stock" },
      ],
    },
    {
      key: "foundry",
      label: "Foundry",
      icon: <FaFoursquare />,
      children: [
        { label: "Foundry", path: "/foundry" },
        { label: "Spectro Component", path: "/spectro" },
      ],
    },
    {
      key: "inProduction",
      label: "In Production",
      icon: <TbBrandProducthunt />,
      children: [{ label: "In Prod", path: "/in-production" }],
    },
    {
      key: "qc",
      label: "QC",
      icon: <AiFillQqCircle />,
      children: [{ label: "QC", path: "/qc" }],
    },
    {
      key: "aging",
      label: "Aging",
      icon: <LiaGitlab />,
      children: [{ label: "Aging", path: "/aging" }],
    },
    {
      key: "packing",
      label: "Packing",
      icon: <SiCloudfoundry />,
      children: [{ label: "Packing", path: "/packing" }],
    },
    {
      key: "settings",
      label: "Settings",
      icon: <IoMdSettings />,
      children: [
        { label: "User", path: "/settings/users" },
        { label: "Menu-Master", path: "/settings/menu-master" },
        { label: "Menu-Permission", path: "/settings/menu-permission" },
        { label: "Nalco-Master", path: "/settings/nalco-master" },
      ],
    },
  ];

  useEffect(() => {
    localStorage.setItem("sidebar-expanded", !sidebarCollapsed);
    document.body.classList.toggle("sidebar-expanded", !sidebarCollapsed);
  }, [sidebarCollapsed]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebar.current && !sidebar.current.contains(event.target)) {
        setSidebarOpen(false);
        setHoveredGroup(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);

  return (
    <>
      <aside
        ref={sidebar}
        className={`overflow-visible fixed top-0 left-0 z-50 h-screen rounded-xl transition-all duration-300 
        bg-white text-primary dark:bg-primary dark:text-white shadow-xl 
        ${sidebarCollapsed ? "w-15" : "w-54 overflow-y-auto"} 
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} 
        lg:translate-x-0 lg:top-16 lg:h-[calc(120vh-5rem)]`}
      >
        {/* Logo */}
        <div className="flex items-center justify-center py-4 border-b border-black/10">
          <NavLink to="/">
            <img
              src={sidebarCollapsed ? Logo1 : Logo}
              alt="Logo"
              className="h-10"
            />
          </NavLink>
        </div>

        {/* Menu */}
        <nav className="mt-4 px-2 pb-6 relative overflow-y-scroll h-[calc(100vh-200px)] pr-1">
          {menuGroups.map((group, groupIndex) => {
            const isOpen = openGroups[group.key];

            return (
              <div
                key={group.key}
                className="mb-4 relative group"
                onMouseEnter={() =>
                  sidebarCollapsed && setHoveredGroup(group.key)
                }
              >
                <button
                  onClick={() => {
                    if (sidebarCollapsed) return;
                    toggleGroup(group.key);
                  }}
                  className={`w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg 
                  transition-all duration-300 
                  hover:bg-black/10 dark:hover:bg-white/10 
                  ${isOpen
                      ? "bg-black/5 dark:bg-white/10 text-primary/80 dark:text-white"
                      : "text-primary dark:text-white"
                    }
                  
                  `}
                >
                  <div className="flex items-center gap-3">
                    <span className="text-xl">{group.icon}</span>
                    {!sidebarCollapsed && (
                      <span className="text-sm font-medium">{group.label}</span>
                    )}
                  </div>
                  {!sidebarCollapsed && (
                    <IoIosArrowDown
                      className={`transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0"
                        }`}
                    />
                  )}
                </button>

                {/* Expanded menu */}
                {!sidebarCollapsed && isOpen && (
                  <ul className="mt-2 pl-6 space-y-1">
                    {group.children.map((item, idx) => {
                      const isItemActive = pathname === item.path;
                      return (
                        <li key={idx}>
                          <NavLink
                            to={item.path}
                            className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-all duration-300 
                            hover:bg-black/5 dark:hover:bg-white/10 
                            ${isItemActive
                                ? "text-primary/90 dark:text-yellow-400"
                                : "text-primary dark:text-gray-300"
                              }`}
                          >
                            <GoDash /> {item.label}
                          </NavLink>
                        </li>
                      );
                    })}
                  </ul>
                )}

                {/* Hover Card (Collapsed Mode) */}
                {sidebarCollapsed && hoveredGroup === group.key && (
                  <div
                    ref={(el) => {
                      if (el) {
                        const sidebarTopOffset = 80 + groupIndex * 48;
                        const hoverCardHeight =
                          group.children.length * 40 + 160;
                        const maxTop =
                          window.innerHeight - hoverCardHeight - 20;

                        const safeTop = Math.min(sidebarTopOffset, maxTop);
                        el.style.top = `${safeTop}px`;
                      }
                    }}
                    className="fixed left-16 z-50 min-w-[200px] max-h-[300px] overflow-y-auto bg-white dark:bg-primary text-primary dark:text-white rounded-lg shadow-lg p-2"
                  >
                    <div className="text-xs uppercase tracking-widest mb-2 px-2 border-b p-2">
                      {group.label}
                    </div>
                    <ul className="space-y-1">
                      {group.children.map((item, itemIdx) => {
                        const isItemActive = pathname === item.path;
                        return (
                          <li key={itemIdx}>
                            <NavLink
                              to={item.path}
                              className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm transition 
                hover:bg-white/10 dark:hover:bg-white/10 
                ${isItemActive
                                  ? "text-blue-600 dark:text-yellow-400"
                                  : "text-primary dark:text-white"
                                }`}
                            >
                              <span>{item.label}</span>
                            </NavLink>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            );
          })}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
